import React, { useContext } from 'react';
import { MFBeaconButton } from '../Beacon/BeaconComponents';
import { FlowContext } from '../../core/flow-engine';
import styles from '../../screens/ProfileScreen/style.css';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';
import { redirectToAccountFinder } from '../../flows/shared/utils';

const ProfileScreenButtons = ({
  multiBuyTickers,
  handleContinueClick = false,
  handleBackClick = false
}) => {
  const { next } = useContext(FlowContext);
  const navigateOnBackClick = handleBackClick || redirectToAccountFinder;

  return (
    <div className="button-container">
      <MFBeaconButton
        data-e2e="basic-PI-continue"
        data-name={generateGeneralTestID('BasicPI', 'ContinueButton')}
        id="basicPIContinue"
        variant="primary"
        className="continue-btn"
        onClick={handleContinueClick || next(multiBuyTickers)}
        label="Continue"
      />
      <MFBeaconButton
        data-e2e="basic-PI-back"
        data-name={generateGeneralTestID('BasicPI', 'BackButton')}
        id="basicPIBack"
        variant="secondary"
        className="beacon-button-margin-override"
        size="normal"
        onClick={navigateOnBackClick}
        label="Back"
      />
      <style jsx>{styles}</style>
    </div>
  );
};

export default ProfileScreenButtons;
